<template>
  <ItemPage
    title="Novo Artigo"
    size="sm"
    :actions="actions"
  >
    <div class="d-flex flex-row align-center pb-10">
      <div class="d-flex flex-fill flex-column">
        <div class="font-weight-bold">
          Capa do artigo
        </div>
        <div class="text-body-2 text--secondary mt-1">
          A imagem de capa deverá ser nas dimensões 840x360 e tipos (*.jpg, *.png)
        </div>
      </div>

      <v-btn
        v-if="displayCoverButton"
        color="primary"
        text
        @click="openUploadImageDialog"
      >
        <v-icon left>
          mdi-cloud-upload
        </v-icon> Enviar capa
      </v-btn>
      <template v-else>
        <v-icon
          left
          color="green darken-2"
        >
          mdi-cloud-check
        </v-icon> Capa enviada
      </template>
    </div>
    <div class="d-flex flex-row align-center pb-10">
      <div class="d-flex flex-fill flex-column">
        <div class="font-weight-bold">
          Artigo
        </div>
        <div class="text-body-2 text--secondary mt-1">
          Envie o artigo no formato (*.zip) e aguarde sua publicação.
        </div>
      </div>

      <v-btn
        v-if="displayMaterialButton"
        color="primary"
        text
        @click="openUploadFileDialog"
      >
        <v-icon left>
          mdi-cloud-upload
        </v-icon> Enviar arquivo
      </v-btn>
      <template v-else>
        <v-icon
          left
          color="green darken-2"
        >
          mdi-cloud-check
        </v-icon> Arquivo enviado
      </template>
    </div>

    <v-form ref="form">
      <v-text-field
        v-model="title"
        label="Titulo"
        placeholder="Insira o titulo do artigo que será enviado"
        :error-messages="errors.title"
        :disabled="!academicArticlesCreate"
        outlined
      />
      <v-text-field
        v-model="author"
        label="Autor"
        placeholder="Insira o nome do autor do artigo"
        outlined
        :error-messages="errors.description"
        :disabled="!academicArticlesCreate"
      />

      <v-textarea
        v-model="description"
        counter
        label="Descrição"
        placeholder="Insira uma breve introdução ao conteudo do artigo"
        outlined
        :error-messages="errors.description"
        :disabled="!academicArticlesCreate"
      />
    </v-form>
  </ItemPage>
</template>

<script>
import utils from '@/api/utils.js'
import ItemPage from '@/components/pages/ItemPage.vue'
import UploadImageDialog from '@/components/settings/UploadImageDialog.vue'
import UploadFileDialog from '@/components/settings/UploadFileDialog.vue'

export default {
  components: {
    ItemPage
  },
  data () {
    return {
      waitEnable: true,
      loading: false,
      btnDisable: true,
      rulesName: [
        value => !!value || 'Preenchimento obrigatório.'
      ],
      title: '',
      author: '',
      description: '',
      temporary_upload_file: false,
      cover_temporary_upload_file: false,
      type: null,
      gradelevels: [],
      files: [],
      errors: [],
      renderUpMaterial: 0,
      renderUpCoverMaterial: 0
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Salvar',
          action: this.newArticle,
          icon: 'mdi-floppy',
          disabled: this.btnDisable
        }
      ]
    },
    displayCoverButton () {
      return !this.cover_temporary_upload_file
    },
    displayMaterialButton () {
      return !this.temporary_upload_file
    },
    academicArticlesCreate () {
      return utils.checkPermissions('academic-articles.create')
    }
  },
  methods: {

    getErrors (data) {
      if (data.data.errors) {
        this.errors = utils.setErrorsData(data.data.errors)
      } else {
        throw (data)
      }
    },
    checkSavePermission () {
      if (this.temporary_upload_file && this.cover_temporary_upload_file) {
        this.btnDisable = false
      } else {
        this.btnDisable = true
      }
    },
    setMaterialFile (data) {
      this.temporary_upload_file = data.id
      this.checkSavePermission()
    },
    setCoverMaterialFile (data) {
      this.cover_temporary_upload_file = data.id
      this.checkSavePermission()
    },
    validate () {
      return this.$refs.form.validate()
    },
    sizes (data) {
      return utils.size(data)
    },
    uploadMaterial () {
      this.waitEnable = false
      this.waitingUploadCover = false
    },

    openUploadImageDialog () {
      this.$dialog.custom(UploadImageDialog).with({ title: 'da capa' }).show()
        .then(async (formData) => {
          if (!formData) {
            return
          }
          try {
            const idTempFile = await this.$api.uploadCoverArticle(formData)
            this.setCoverMaterialFile(idTempFile)
          } catch {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar a capa, tente novamente mais tarde.', color: 'red' })
          }
        })
    },

    openUploadFileDialog () {
      this.$dialog.custom(UploadFileDialog).with({ title: 'do artigo' }).show()
        .then(async (formData) => {
          if (!formData) {
            return
          }
          try {
            const idTempFile = await this.$api.uploadArticle(formData)
            this.setMaterialFile(idTempFile)
          } catch {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar o artigo, tente novamente mais tarde.', color: 'red' })
          }
        })
    },

    async newArticle () {
      this.loading = true
      this.waitEnable = true
      const data = {
        temporary_upload_file_id: this.temporary_upload_file,
        cover_temporary_upload_file_id: this.cover_temporary_upload_file,
        title: this.title,
        description: this.description,
        author: this.author
      }
      try {
        await this.$api.NewArticle(data)
        this.$store.dispatch('setSnackBar', { text: 'Artigo cadastrado com sucesso' })
        this.$router.push({ name: 'conteudos.artigos' })
      } catch (e) {
        this.loading = false
        this.waitEnable = false
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e.response)
      }
      this.loading = false
      this.waitEnable = false
    }
  }
}
</script>
